import { render } from "./ProductSaleType.vue?vue&type=template&id=0d057534"
import script from "./ProductSaleType.vue?vue&type=script&lang=js"
export * from "./ProductSaleType.vue?vue&type=script&lang=js"

import exportComponent from "F:\\admin_om\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__